import styled from 'styled-components';

export const Scroller = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;